import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist"; 
import { ActivityReducer } from './ActivityReducer';
import { AuthReducer } from './AuthReducer';
import CommonReducer from './CommonReducer';
import { HomeReducer } from './HomeReducer';
import { RdbmActivityReducer } from './RbdmActivityReducer';
import { RenewalManageReducer } from './RenewalManageReducer';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import { Buffer } from "buffer";

let SECRET_KEY = process.env.REACT_APP_REDUX_SECRET || "";
let originalSecretKey  =Buffer.from(SECRET_KEY.slice(5, SECRET_KEY.length - 10), 'base64').toString('ascii')

const persistConfig = {
    key:'root',
    storage,
    whitelist:['auth','home','renewal'],
    transforms: [
        encryptTransform({
          secretKey: originalSecretKey,
          onError: function (error) {
            // Handle the error.
          },
        }),
      ],
}

const reducers = combineReducers({
    common: CommonReducer,
    auth: AuthReducer,
    activity:ActivityReducer,
    home:HomeReducer,
    renewal:RenewalManageReducer,
    rdbm:RdbmActivityReducer
});

export default persistReducer(persistConfig, reducers)
 
//export  RootState = reducers